import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExpirationMessageText } from '../../models/user.model';
import { DatePipe } from '@angular/common';
import { CONSTANTS } from '../../models/constants';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-expiration-dialog',
  templateUrl: './expiration-dialog.component.html',
  styleUrls: ['./expiration-dialog.component.scss'],
})
export class ExpirationDialogComponent implements OnInit {
  selectedDate = new FormControl<string | null>(null, Validators.required);
  generateButtonDisabled = !this.selectedDate.valid;
  maxDate: Date;
  minDate: string = this.data.minDate;

  constructor(
    public dialogRef: MatDialogRef<ExpirationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExpirationMessageText,
    private datePipe: DatePipe
  ) {
    this.selectedDate.setValue(this.data.minDate || '');
    this.maxDate = new Date(this.selectedDate.value || '');
    this.maxDate.setFullYear(
      this.maxDate.getFullYear() + CONSTANTS.MAX_EXP_YEAR_FOR_API_KEY
    );
  }

  ngOnInit(): void {
    this.selectedDate.valueChanges.subscribe(value => {
      this.generateButtonDisabled = !this.selectedDate.valid;
      console.log(!this.selectedDate.valid);
    });
  }

  onConfirm(): void {
    if (this.selectedDate.valid && this.selectedDate.value) {
      const formattedDate = this.formatDate(this.selectedDate.value);
      this.dialogRef.close(formattedDate);
    } else {
      this.selectedDate.markAsTouched();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    date.setHours(23, 59, 59, 999);
    return this.datePipe.transform(date, CONSTANTS.EXP_DATE_FORMAT) || '';
  }
}
